import { apiGet } from '../lib/api'

export const TAG_ADD_START = 'TAG_ADD_START'
export const TAG_ADD_SUCCESS = 'TAG_ADD_SUCCESS'
export const TAG_ADD_ERROR = 'TAG_ADD_ERROR'

export const TAG_LOAD_START = 'TAG_LOAD_START'
export const TAG_LOAD_SUCCESS = 'TAG_LOAD_SUCCESS'
export const TAG_LOAD_ERROR = 'TAG_LOAD_ERROR'

export const TAGS_LOAD_START = 'TAGS_LOAD_START'
export const TAGS_LOAD_SUCCESS = 'TAGS_LOAD_SUCCESS'
export const TAGS_LOAD_ERROR = 'TAGS_LOAD_ERROR'

export const TAGS_CLEAR = 'TAGS_CLEAR'
export const TAG_CLEAR = 'TAG_CLEAR'

export const loadTags = () => ({ getState, fetch }) => ({
  type: 'TAGS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'tag',
    getState,
  }),
})

export const loadTagsBySubject = (id) => ({ getState, fetch }) => ({
  type: 'TAGS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `tag/subject/${id}`,
    getState,
  }),
})

export const loadTagsByLanguage = (id) => ({ getState, fetch }) => ({
  type: 'TAGS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `tag/language/${id}`,
    getState,
  }),
})



// WEBPACK FOOTER //
// ./src/common/tags/actions.js